import { Component, Input } from '@angular/core';
import { ModalComponent } from '@appShared/components/modal/modal.component';
import { IPlanDetail, IShareholder } from '@appShared/interfaces/[Model-based]';
import { ShareholderPlanDetailEditComponent } from './shareholder-plan-detail-edit.component';

@Component({
  template: `
    <app-modal title="Stock Plan Detail ({{shareholder?.firstName}} {{shareholder?.lastName}})" [showFooter]="false">
      <app-shareholder-plan-detail-edit
        [planDetail]="planDetail"
        [canEdit]="canEdit"
        (shareholderUpdated)="refreshGrid()">
      </app-shareholder-plan-detail-edit>
    </app-modal>`,
   imports: [ModalComponent, ShareholderPlanDetailEditComponent]
})
export class ShareholderPlanDetailEditModalComponent {
  @Input() shareholder: IShareholder;
  @Input() planDetail: IPlanDetail;
  @Input() canEdit: boolean;
  @Input() refreshGrid: () => void;

  constructor() {}
}
